import { Entity } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { NonLinearStepper } from '~/components/non-linear-stepper/NonLinearStepper';
import { useThemeStore } from '~/components/theme-controller/stores/useThemeStore';
import { CompetingThemes } from '~/modules/overview-knowledge-graph/components/competing-themes/CompetingThemes';
import { RelativePerformance } from '~/modules/overview-knowledge-graph/components/relative-performance/RelativePerformance';
import { CompetitorData } from '~/widgets/knowledge-graph-widget/hooks/useCompetitorsData';
import * as Shared from '~/widgets/theme-widget/tabs/components/stepper-section/StepperSection.styles';
import { RankSection } from '~/widgets/theme-widget/tabs/theme-exposure-tab/components/rank-section/RankSection';

import * as S from './CompetitorOverview.styles';

export const CompetitorOverview = ({
  entity,
  competitor,
}: {
  entity: Entity;
  competitor: CompetitorData;
}) => {
  const { t } = useTranslation(['widget']);
  const { getThemedLogoUrl } = useThemeStore();

  const stepperTitle = t(
    'assetOverview.knowledgeGraph.competitors.tabs.competitorOverview.header',
    { name: entity.name_short || entity.name }
  );

  const {
    competitorData,
    entity: competitorEntity,
    competingThemes,
  } = competitor;

  return (
    <S.Root>
      <Shared.SectionRow data-testid="stepper-section">
        <Shared.HeaderWrapper>
          <Shared.TitleMedium>{stepperTitle}</Shared.TitleMedium>
        </Shared.HeaderWrapper>
        <Shared.StepperWrapper>
          <NonLinearStepper
            activeIndex={0}
            iconSize={18}
            steps={[
              {
                logoUrl: getThemedLogoUrl(entity),
                hoverLabel: entity.name_short || entity.name,
                connectorLabel: t(
                  'assetOverview.knowledgeGraph.competitors.tabs.competitorOverview.connectorLabel'
                ),
                highlightConnector: true,
                isSimple: true,
              },
              {
                logoUrl: getThemedLogoUrl(competitorEntity),
                hoverLabel:
                  competitorEntity.name_short || competitorEntity.name,
                highlightConnector: true,
              },
            ]}
          />
        </Shared.StepperWrapper>
        <Shared.BodySmall>
          {competitorData.relationship.description}
        </Shared.BodySmall>
      </Shared.SectionRow>
      <RankSection
        title={t(
          'assetOverview.knowledgeGraph.competitors.tabs.competitorOverview.rank'
        )}
        label={t(
          'widget:assetOverview.knowledgeGraph.themeExposure.tabs.themeExposure.current'
        )}
        rank={competitorData.relationship.rank}
      />
      <CompetingThemes competingThemes={competingThemes} />
      <RelativePerformance entity={entity} />
    </S.Root>
  );
};
